import React, {Component} from "react";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import {ACTIVITY_TYPE} from "../../../common/Constants";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";

class CrmKTP extends Component {
    render() {
        const {options, activityType, controls, setValue, errors} = this.props;
        return (
            <>
                <div className="grid grid-3x gap-20px">
                    <div id="grid-1">
                        <SimpleInput
                            name="name"
                            label="Name"
                            mandatory
                            errorMessage={errors?.name}
                            value={controls?.name?.value || null}
                            readOnly={activityType !== ACTIVITY_TYPE.CREATE && activityType !== ACTIVITY_TYPE.UPDATE}
                            onChange={({target}) => setValue(target.name, target.value)}
                        />
                        {this.props.box === "CDB" ? (
                            <SimpleInput
                                name="nik"
                                label="NIK"
                                mandatory
                                errorMessage={errors?.nik}
                                value={controls?.nik?.value || null}
                                readOnly={activityType !== ACTIVITY_TYPE.CREATE && activityType !== ACTIVITY_TYPE.UPDATE}
                                onChange={({target}) => setValue(target.name, target.value)}
                            />
                        ) : (
                            <FlexView style={{alignItems: "center"}}>
                                <SimpleInput
                                    name="nik"
                                    label="NIK"
                                    mandatory
                                    errorMessage={errors?.nik}
                                    value={controls?.nik?.value || null}
                                    readOnly={activityType !== ACTIVITY_TYPE.CREATE && activityType !== ACTIVITY_TYPE.UPDATE}
                                    onChange={({target}) => setValue(target.name, target.value)}
                                    style={{width: "auto"}}
                                />
                                {activityType === ACTIVITY_TYPE.CREATE && (
                                    <SimpleButton
                                        onClick={this.props.onClickCheck}
                                    >Cek</SimpleButton>
                                )}
                            </FlexView>
                        )}
                        <SimpleInput
                            name="address"
                            label="Alamat"
                            mandatory
                            errorMessage={errors?.address}
                            value={controls?.address?.value || null}
                            readOnly={activityType !== ACTIVITY_TYPE.CREATE && activityType !== ACTIVITY_TYPE.UPDATE}
                            onChange={({target}) => setValue(target.name, target.value)}
                        />
                        {this.props.box === "CDB" && (
                            <>
                                <SimpleInput
                                    id="input_text_kk_number"
                                    name="kkNumber"
                                    label="No. KK"
                                    mandatory
                                    errorMessage={errors?.kkNumber}
                                    value={controls?.kkNumber?.value || null}
                                    readOnly={activityType !== ACTIVITY_TYPE.CREATE && activityType !== ACTIVITY_TYPE.UPDATE}
                                    onChange={({target}) => setValue(target.name, target.value)}
                                />
                                <SimpleInput
                                    id="input_text_npwp"
                                    name="npwp"
                                    label="NPWP"
                                    errorMessage={errors?.npwp}
                                    value={controls?.npwp?.value || null}
                                    readOnly={activityType !== ACTIVITY_TYPE.CREATE && activityType !== ACTIVITY_TYPE.UPDATE}
                                    onChange={({target}) => setValue(target.name, target.value)}
                                />
                            </>
                        )}
                    </div>
                    <div id="grid-2">
                        <SimpleDDL
                            id="select_options_province"
                            box="search"
                            name="provinceId"
                            label="Provinsi"
                            mandatory
                            isClearable
                            errorMessage={errors?.provinceId}
                            value={controls?.provinceId?.value || null}
                            options={options?.provinceOptions || []}
                            readOnly={activityType !== ACTIVITY_TYPE.CREATE && activityType !== ACTIVITY_TYPE.UPDATE}
                            onChange={(value, {name}) => setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_kabkot"
                            box="search"
                            name="kabkotId"
                            label="Kota/Kabupaten"
                            mandatory
                            isClearable
                            errorMessage={errors?.kabkotId}
                            value={controls?.kabkotId?.value || null}
                            options={options?.kabkotOptions || []}
                            readOnly={activityType !== ACTIVITY_TYPE.CREATE && activityType !== ACTIVITY_TYPE.UPDATE}
                            onChange={(value, {name}) => setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_kecamatan"
                            box="search"
                            name="kecamatanId"
                            label="Kecamatan"
                            mandatory
                            isClearable
                            errorMessage={errors?.kecamatanId}
                            value={controls?.kecamatanId?.value || null}
                            options={options?.kecamatanOptions || []}
                            readOnly={activityType !== ACTIVITY_TYPE.CREATE && activityType !== ACTIVITY_TYPE.UPDATE}
                            onChange={(value, {name}) => setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_kelurahan"
                            box="search"
                            name="kelurahanId"
                            label="Kelurahan"
                            mandatory
                            isClearable
                            errorMessage={errors?.kelurahanId}
                            value={controls?.kelurahanId?.value || null}
                            options={options?.kelurahanOptions || []}
                            readOnly={activityType !== ACTIVITY_TYPE.CREATE && activityType !== ACTIVITY_TYPE.UPDATE}
                            // onChange={(value, {name}) => setValue(name, value)}
                            onChange={(value, {name}) => {
                                setValue(name, value);
                                setValue('zipcode', null);
                            }}
                        />
                        <SimpleDDL
                            id="select_options_zip_code"
                            box="search"
                            name="zipcode"
                            label="Kode Pos"
                            mandatory
                            isClearable
                            errorMessage={errors?.zipcode}
                            value={controls?.zipcode?.value || null}
                            options={options?.zipCodeOptions || []}
                            readOnly={activityType !== ACTIVITY_TYPE.CREATE && activityType !== ACTIVITY_TYPE.UPDATE}
                            onChange={(value, {name}) => setValue(name, value)}
                        />
                    </div>
                    <div id="grid-3">
                        <SimpleDDL
                            id="select_options_gender"
                            box="search"
                            name="gender"
                            label="Jenis Kelamin"
                            mandatory
                            isClearable
                            errorMessage={errors?.gender}
                            value={controls?.gender?.value || null}
                            options={options?.genderOptions || []}
                            readOnly={activityType !== ACTIVITY_TYPE.CREATE && activityType !== ACTIVITY_TYPE.UPDATE}
                            onChange={(value, {name}) => setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_job1"
                            box="search"
                            name="job1"
                            label="Pekerjaan 1"
                            mandatory
                            isClearable
                            options={options?.jobOptions || []}
                            errorMessage={errors?.job1}
                            value={controls?.job1?.value || ""}
                            readOnly={activityType !== ACTIVITY_TYPE.CREATE && activityType !== ACTIVITY_TYPE.UPDATE}
                            onChange={(value, {name}) => setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_job2"
                            box="search"
                            name="job2"
                            label="Pekerjaan 2"
                            isClearable
                            options={options?.jobOptions || []}
                            value={controls?.job2?.value || ""}
                            readOnly={activityType !== ACTIVITY_TYPE.CREATE && activityType !== ACTIVITY_TYPE.UPDATE}
                            onChange={(value, {name}) => setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_religion"
                            box="search"
                            name="religion"
                            label="Agama"
                            mandatory
                            isClearable
                            errorMessage={errors?.religion}
                            value={controls?.religion?.value || null}
                            options={options?.religionOptions || []}
                            readOnly={activityType !== ACTIVITY_TYPE.CREATE && activityType !== ACTIVITY_TYPE.UPDATE}
                            onChange={(value, {name}) => setValue(name, value)}
                        />
                    </div>
                </div>
            </>
        )
    };
}

export default CrmKTP;
